import {
    GET_TEAM_COMPARE_DATA_REQUEST,
    GET_TEAM_COMPARE_DATA_SUCCESS,
    GET_TEAM_COMPARE_DATA_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getTeamCompareDataByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TEAM_COMPARE_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case GET_TEAM_COMPARE_DATA_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_TEAM_COMPARE_DATA_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default getTeamCompareDataByAdminReducer;
